(() => {
  const GLOBAL_KEY = '__mtBlackFridayOffers';
  const SECTION_SELECTOR = '[data-mt-blackfriday-offers]';
  const resetTimers = new WeakMap();

  if (window[GLOBAL_KEY]) {
    window[GLOBAL_KEY].initAll(document);
    return;
  }

  const findSections = (container = document) => {
    const sections = [];

    if (container?.matches?.(SECTION_SELECTOR)) sections.push(container);
    container?.querySelectorAll?.(SECTION_SELECTOR).forEach((section) => sections.push(section));

    return sections;
  };

  const interpolateMessage = (template, code) => String(template || '').replace(/\[code\]/g, code);

  const copyText = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return;
    }

    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.append(textarea);
    textarea.select();

    const copied = document.execCommand('copy');
    textarea.remove();

    if (!copied) throw new Error('Copy failed');
  };

  const selectCode = (button) => {
    const code = button.closest('.mt-blackfriday-offers__row')?.querySelector('[data-offer-code]');
    if (!code || !window.getSelection || !document.createRange) return;

    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(code);
    selection.removeAllRanges();
    selection.addRange(range);
  };

  const resetButton = (button) => {
    const label = button.querySelector('[data-copy-button-label]');
    if (label) label.textContent = button.dataset.originalLabel || '';

    const timerId = resetTimers.get(button);
    if (timerId) window.clearTimeout(timerId);
    resetTimers.delete(button);
  };

  const handleCopy = async (section, button) => {
    const code = button.dataset.copyCode || '';
    if (!code) return;

    const label = button.querySelector('[data-copy-button-label]');
    const liveStatus = section.querySelector('[data-copy-live-status]');
    const copiedLabel = section.dataset.copiedLabel || '';

    if (!button.dataset.originalLabel && label) {
      button.dataset.originalLabel = label.textContent || '';
    }

    resetButton(button);

    try {
      await copyText(code);

      if (label && copiedLabel) label.textContent = copiedLabel;
      if (liveStatus) liveStatus.textContent = interpolateMessage(section.dataset.copySuccessMessage, code);

      resetTimers.set(button, window.setTimeout(() => resetButton(button), 2200));
    } catch (error) {
      if (liveStatus) liveStatus.textContent = interpolateMessage(section.dataset.copyErrorMessage, code);
      selectCode(button);
    }
  };

  const initSection = (section) => {
    if (!section || section.dataset.offersInitialized === 'true') return;
    section.dataset.offersInitialized = 'true';

    const toggle = section.querySelector('[data-offers-toggle]');
    const rows = section.querySelector('[data-offer-rows]');

    toggle?.addEventListener('click', () => {
      if (!rows) return;

      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      rows.hidden = expanded;
    });

    section.addEventListener('click', (event) => {
      const copyButton = event.target.closest('[data-copy-code]');
      if (!copyButton || !section.contains(copyButton)) return;
      handleCopy(section, copyButton);
    });
  };

  const initAll = (container = document) => findSections(container).forEach(initSection);

  window[GLOBAL_KEY] = { initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    findSections(event.target).forEach((section) => {
      section.querySelectorAll('[data-copy-code]').forEach(resetButton);
    });
  });
})();
